<template>
  <div>
    <v-menu v-model="show" :close-on-content-click="false" :max-width="500" offset-y>
      <main-button slot="activator" flat text="Options" />
      <v-card>
        <v-container style="padding-bottom: 0">
          <v-card-title primary-title>
            <span class="dialog-title">Accreditation options</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="form.format"
              :items="formats"
              label="Choose format"
              type="text"
              item-text="label"
              return-object
            />
            <v-radio-group v-model="form.orientation" row>
              <v-radio label="Portrait" value="PORTRAIT" />
              <v-radio label="Landscape" value="LANDSCAPE" />
            </v-radio-group>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click="show = false"> Cancel </v-btn>
          <v-btn color="primary" flat @click="saveOptions"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <delete-dialog
      :show.sync="openWarningDialog"
      :on-delete="changeOptions"
      title="Warning"
      content="This action could potentially be destructive and it is irreversible. Are you sure you want to continue?"
      action-message="Change format"
    />
  </div>
</template>

<script>
import DeleteDialog from '../shared/dialogs/delete-dialog.vue'
import { formats } from './builder.utils'

export default {
  name: 'options',
  components: {
    DeleteDialog,
  },
  props: {
    options: Object,
  },
  data() {
    return {
      form: { ...this.options },
      formats,
      show: false,
      openWarningDialog: false,
    }
  },
  watch: {
    'form.format': function () {
      this.form.orientation = this.form.format.defaultOrientation
    },
  },
  methods: {
    saveOptions() {
      this.show = false
      this.openWarningDialog = true
    },
    changeOptions() {
      const {
        orientation,
        format: { name },
      } = this.form
      const format = this.formats.find(f => f.name === name)

      this.$emit('update:options', {
        orientation,
        format,
      })
      this.openWarningDialog = false
    },
  },
}
</script>

<style scoped></style>
